<template>
  <div>
    <b-field grouped group-multiline class="desktop-search mb-3">
      <b-field class="my-2 control">
        <search
          v-model="query.filter.address"
          @selectProperty="(item) => $emit('selectProperty', item)"
          @selectListing="(item) => $emit('selectListing', item)"
          @search="apply()"
          @selectCity="(city) => $emit('selectCity', city)"
          @selectAddress="(city) => $emit('selectAddress', city)"
        ></search>
      </b-field>

      <b-dropdown
        ref="price_range_filter"
        position="is-bottom-left"
        append-to-body
        aria-role="menu"
        trap-focus
        @active-change="price_range_suggest_mode = 'min'"
      >
        <template #trigger>
          <a
            v-bind:class="{ 'has-background-info-light': query.filter.price.min || query.filter.price.max }"
            class="navbar-item"
            role="button">
            <span v-if="!query.filter.price.min && !query.filter.price.max">Price range</span>
            <span v-if="query.filter.price.min && !query.filter.price.max">{{kFormatter(query.filter.price.min)}}+</span>
            <span v-if="!query.filter.price.min && query.filter.price.max">{{kFormatter(query.filter.price.max)}}</span>
            <span v-if="query.filter.price.min && query.filter.price.max">{{kFormatter(query.filter.price.min)}} - {{kFormatter(query.filter.price.max)}}</span>
            <b-icon icon="menu-down"></b-icon>
            <div class="b-icon-no-text" @click.stop="query.filter.price.min = null; query.filter.price.max = null; apply()">
            <b-icon
                    v-if="query.filter.price.min || query.filter.price.max" icon="close-circle"></b-icon>
              </div>
          </a>
        </template>
        <b-dropdown-item

          aria-role="menu-item"
          :focusable="false"
          custom
          paddingless>
          <form action="">
            <div class="modal-card" style="width:300px;">
              <section class="modal-card-body">
                <label class="label">Price range</label>
                <b-field>
                  <b-input
                    placeholder="Min"
                    class="mr-2"
                    @focus="price_range_suggest_mode ='min'"
                    v-model="query.filter.price.min"
                    ref="price_range_suggest_mode_min"
                  />

                  <b-input
                  placeholder="Max"
                  class="ml-2"
                  @focus="price_range_suggest_mode ='max'"
                  v-model="query.filter.price.max"
                  ref="price_range_suggest_mode_max"
                  />
                </b-field>
                <div v-if="price_range_suggest_mode === 'min'" class="price-range-suggest-box price-range-suggest-min">
                  <div @click="priceRangeMinClick(option)" class="price-range-suggest-item" v-for="(option, index) in price_range_suggest[query.filter.deal_type ? query.filter.deal_type : 'BUY'].min" v-bind:key="index">
                    {{money(option)}}
                  </div>
                </div>
                <div v-if="price_range_suggest_mode === 'max'" class="price-range-suggest-box price-range-suggest-max">
                  <div @click="priceRangeMaxClick(option)" class="price-range-suggest-item" v-for="(option, index) in price_range_suggest[query.filter.deal_type ? query.filter.deal_type : 'BUY'].max" v-bind:key="index">
                    {{money(option)}}
                  </div>
                </div>
              </section>
              <footer class="modal-card-foot">
                <b-button
                  label="Apply"
                  type="is-primary" @click="apply('price_range_filter')"/>
              </footer>
            </div>
          </form>
        </b-dropdown-item>
      </b-dropdown>

      <b-dropdown
        ref="property_type_filter"
        position="is-bottom-left"
        append-to-body
        aria-role="menu"
        trap-focus

      >
        <template #trigger>
          <a
            v-bind:class="{ 'has-background-info-light': !!query.filter.property_type }"
            class="navbar-item"
            role="button">
            <span v-if="!query.filter.property_type">Property type</span>
            <span v-if="query.filter.property_type">{{property_type_map[query.filter.property_type]}}</span>

            <b-icon icon="menu-down"></b-icon>
            <div class="b-icon-no-text"
                 v-if="query.filter.property_type"
                 @click.stop="query.filter.property_type = null; apply()">
              <b-icon
                 icon="close-circle"></b-icon>
            </div>
          </a>
        </template>


        <b-dropdown-item

          aria-role="menu-item"
          :focusable="false"
          custom
          paddingless>
          <form action="">
            <div class="modal-card" style="width:300px;">
              <section class="modal-card-body">
                <label class="label">Property type</label>
                  <b-field>
                    <b-radio v-model="query.filter.property_type"
                             :native-value="null">
                      Any
                    </b-radio>
                  </b-field>
<!--                <b-field>-->
<!--                  <b-radio v-model="query.filter.property_type"-->
<!--                           native-value="RINC">-->
<!--                    Multi-Family-->
<!--                  </b-radio>-->
<!--                </b-field>-->
                <b-field>
                  <b-radio v-model="query.filter.property_type"
                           native-value="FRM">
                    Farm
                  </b-radio>
                </b-field>
                <b-field>
                  <b-radio v-model="query.filter.property_type"
                           native-value="RNT">
                    Rental
                  </b-radio>
                </b-field>
                <b-field>
                  <b-radio v-model="query.filter.property_type"
                           native-value="RES">
                    Residential
                  </b-radio>
                </b-field>
                <b-field>
                  <b-radio v-model="query.filter.property_type"
                           native-value="MLF">
                    Multifamily
                  </b-radio>
                </b-field>
                <b-field>
                  <b-radio v-model="query.filter.property_type"
                           native-value="CRE">
                    Commercial
                  </b-radio>
                </b-field>
                <b-field>
                  <b-radio v-model="query.filter.property_type"
                           native-value="LND">
                    Land
                  </b-radio>
                </b-field>
<!--                <b-field>-->
<!--                  <b-radio v-model="query.filter.property_type"-->
<!--                           native-value="OTHER">-->
<!--                    Other-->
<!--                  </b-radio>-->
<!--                </b-field>-->
              </section>
              <footer class="modal-card-foot">
                <b-button
                  label="Apply"
                  type="is-primary" @click="apply('property_type_filter')"/>
              </footer>
            </div>
          </form>
        </b-dropdown-item>
      </b-dropdown>
<!--      <b-dropdown-->
<!--        position="is-bottom-left"-->
<!--        append-to-body-->
<!--        aria-role="menu"-->
<!--        trap-focus-->
<!--        ref="deal_type_filter"-->

<!--      >-->
<!--        <template #trigger>-->
<!--          <a-->
<!--            v-bind:class="{ 'has-background-info-light': !!query.filter.deal_type }"-->
<!--            class="navbar-item "-->
<!--            role="button">-->
<!--            <span v-if="!query.filter.deal_type">Deal type</span>-->
<!--            <span v-if="query.filter.deal_type">{{deal_map[query.filter.deal_type]}}</span>-->
<!--            <b-icon icon="menu-down"></b-icon>-->
<!--            <div class="b-icon-no-text"-->
<!--                 v-if="query.filter.deal_type"-->
<!--                 @click.stop="query.filter.deal_type = null; apply()">-->
<!--              <b-icon-->
<!--                icon="close-circle"></b-icon>-->
<!--            </div>-->
<!--          </a>-->
<!--        </template>-->


<!--        <b-dropdown-item-->
<!--          aria-role="menu-item"-->
<!--          :focusable="false"-->
<!--          custom-->
<!--          paddingless>-->
<!--          <form action="">-->
<!--            <div class="modal-card" style="width:300px;">-->
<!--              <section class="modal-card-body">-->
<!--                <label class="label">Deal type</label>-->
<!--                <b-field>-->
<!--                  <b-radio v-model="query.filter.deal_type"-->
<!--                           :native-value="null">-->
<!--                    Any-->
<!--                  </b-radio>-->
<!--                </b-field>-->
<!--                <b-field>-->
<!--                  <b-radio v-model="query.filter.deal_type"-->
<!--                           native-value="BUY">-->
<!--                    For sale-->
<!--                  </b-radio>-->
<!--                </b-field>-->
<!--                <b-field>-->
<!--                  <b-radio v-model="query.filter.deal_type"-->
<!--                           native-value="RENT">-->
<!--                    For rent-->
<!--                  </b-radio>-->
<!--                </b-field>-->
<!--              </section>-->
<!--              <footer class="modal-card-foot">-->
<!--                <b-button-->
<!--                  label="Apply"-->
<!--                  type="is-primary"  @click="apply('deal_type_filter')"/>-->
<!--              </footer>-->
<!--            </div>-->
<!--          </form>-->
<!--        </b-dropdown-item>-->
<!--      </b-dropdown>-->

      <b-dropdown
        ref="bedroom_filter"
        position="is-bottom-left"
        append-to-body
        aria-role="menu"
        trap-focus
        @active-change="bedroom_suggest_mode = 'min'"
      >
        <template #trigger>
          <a
            v-bind:class="{ 'has-background-info-light': query.filter.bedroom.min || query.filter.bedroom.max }"
            class="navbar-item"
            role="button">
            <span v-if="!query.filter.bedroom.min && !query.filter.bedroom.max">Beds</span>
            <span v-if="query.filter.bedroom.min && !query.filter.bedroom.max">{{query.filter.bedroom.min}} Bed+</span>
            <span v-if="!query.filter.bedroom.min && query.filter.bedroom.max">Max {{query.filter.bedroom.max}} Beds</span>
            <span v-if="query.filter.bedroom.min && query.filter.bedroom.max && (query.filter.bedroom.min !== query.filter.bedroom.max)">{{query.filter.bedroom.min}} - {{query.filter.bedroom.max}} Beds</span>
            <span v-if="query.filter.bedroom.min && query.filter.bedroom.max && (query.filter.bedroom.min === query.filter.bedroom.max)">{{query.filter.bedroom.min}} Beds</span>
            <b-icon icon="menu-down"></b-icon>
            <div class="b-icon-no-text" @click.stop="query.filter.bedroom.min = null; query.filter.bedroom.max = null; apply()">
              <b-icon
                v-if="query.filter.bedroom.min || query.filter.bedroom.max" icon="close-circle"></b-icon>
            </div>
          </a>
        </template>
        <b-dropdown-item

          aria-role="menu-item"
          :focusable="false"
          custom
          paddingless>
          <form action="">
            <div class="modal-card" style="width:300px;">
              <section class="modal-card-body">
                <label class="label">Bedrooms</label>
                <b-field>
                  <b-input
                    placeholder="Min"
                    class="mr-2"
                    @focus="() => {this.bedroom_suggest_mode ='min'}"
                    v-model="query.filter.bedroom.min"
                    ref="bedroom_suggest_mode_min"

                  />

                  <b-input
                    placeholder="Max"
                    class="ml-2"
                    @focus="() => {this.bedroom_suggest_mode ='max'}"
                    v-model="query.filter.bedroom.max"
                    ref="bedroom_suggest_mode_max"

                  />
                </b-field>
                <div v-if="bedroom_suggest_mode === 'min'" class="price-range-suggest-box price-range-suggest-min">
                  <div @click.stop="bedroomMinClick(option)" class="price-range-suggest-item" v-for="(option, index) in bedroom_suggest.min" v-bind:key="index">
                    {{index}}
                  </div>
                </div>
                <div v-if="bedroom_suggest_mode === 'max'" class="price-range-suggest-box price-range-suggest-max">
                  <div  @click.stop="bedroomMaxClick(null)" class="price-range-suggest-item" >
                    No max
                  </div>
                  <template v-for="(option, index) in bedroom_suggest.max">
                  <div v-if="option >= query.filter.bedroom.min" @click.stop="bedroomMaxClick(option)" class="price-range-suggest-item"  v-bind:key="index">
                    {{index}}
                  </div>
                  </template>
                </div>
              </section>
              <footer class="modal-card-foot">
                <b-button
                  label="Apply"
                  type="is-primary" @click="apply('bedroom_filter')"/>
              </footer>
            </div>
          </form>
        </b-dropdown-item>
      </b-dropdown>

      <a
        v-bind:class="{ 'has-background-info-light': hasMoreFilter() }"
        class="navbar-item ml-2"
        role="button"
        @click.stop="isMoreFilterModalActive = true"
      >
        <span>More</span>
        <b-icon icon="menu-down"></b-icon>
        <div class="b-icon-no-text" @click.stop="clearMoreFilter(); apply()">
          <b-icon
            v-if="hasMoreFilter()" icon="close-circle"></b-icon>
        </div>
      </a>

    </b-field>

  <b-modal
    v-model="isMoreFilterModalActive"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="More filters"
    close-button-aria-label="Close"
    aria-modal
    class="moreFilterModal"
    can-cancel
    ref="more_filter"
  >

    <div class="modal-card" style="width: auto">
      <section class="modal-card-body">
        <b-field class="my-2 control" label="Baths">
          <div class="container">
            <div class="row mb-2">
              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="null">
                  Any
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="1">
                  1+ Bathrooms
                </b-radio>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="2">
                  2+ Bathrooms
                </b-radio>
              </div>
              <div class="col-md-6">
                <b-radio v-model="query.filter.bathroom.min"
                         :native-value="3">
                  3+ Bathrooms
                </b-radio>
              </div>
            </div>
          </div>
        </b-field>
        <b-field class="my-2 control" label="Square Feet">
          <b-select class="mr-2" v-model="query.filter.square.min">
            <option :value="null">No min</option>
            <option :value="option" v-for="(option, index) in square_suggest.min" v-bind:key="index">
              {{option}}
            </option>

          </b-select>

          <b-select class="ml-2" v-model="query.filter.square.max">
            <option :value="null">No max</option>
            <template v-for="(option, index) in square_suggest.max">
              <option v-if="option >= query.filter.square.min" :value="option"  v-bind:key="index">
                {{option}}
              </option>
            </template>
          </b-select>
        </b-field>
      </section>
    </div>
    <footer class="modal-card-foot">
      <b-button
        label="Clear"
        @click.stop="clearMoreFilter()" />
      <b-button
        label="Apply"
        type="is-primary"
        @click.stop="apply(); isMoreFilterModalActive = false;"
      />
    </footer>

  </b-modal>
</div>
</template>

<script>
// import {mapActions} from 'vuex';
// import { mapFields } from 'vuex-map-fields';
// import {getCityById, getPropertiesByQuery} from "@/components/front/realty/repository";
// import {Result} from "@/components/front/realty/propertiesQueryResult";
// import {Query} from "@/components/front/realty/propertiesQueryBuilder";
// import detail from "@/components/front/realty/detail/detailv2";
// import leaflet from "@/components/front/realty/realtor_properties_list/map/leaflet";
// import _ from 'lodash';
// import FixedHeader from 'vue-fixed-header'
// import configDefault from "@/components/front/realty/realtor_properties_list/map/config";
// import {localCache} from "@/components/front/realty/localCache";
import search from "@/components/listings_map/search/input";
// import fullDetail from "@/components/front/realty/realtor_properties_detail/index";

export default {
  name: 'front_realty_realtor_properties_list',
  components: { search},

  props: {
    value:null
  },
  data() {
    return {
      square_suggest: {
        min:[
          400,
          500,
          600,
          700,
          800,
          900,
          1000,
          1100,
          1200,
          1300,
          1400,
          1500,
          1600,
          1700,
          1800,
          1900,
          2000,
          2500,
          3000,
          3500,
          4000,
          4500
        ],
        max:[
          400,
          500,
          600,
          700,
          800,
          900,
          1000,
          1100,
          1200,
          1300,
          1400,
          1500,
          1600,
          1700,
          1800,
          1900,
          2000,
          2500,
          3000,
          3500,
          4000,
          4500
        ],
      },
      isMoreFilterModalActive: false,
      bedroom_suggest_mode: "min",
      bedroom_suggest: {
        min : {
          "1+ Bed" : 1,
          "2+ Beds" : 2,
          "3+ Beds" : 3,
          "4+ Beds" : 4
        },
        max: {
          "1 Bed" : 1,
          "2 Beds" : 2,
          "3 Beds" : 3,
          "4 Beds" : 4
        }
      },
      price_range_suggest_mode: "min",
      price_range_suggest:{
        "BUY": {
          "min" : [
            40000,
            80000,
            100000,
            120000,
            150000,
            180000
          ],
          "max" : [
            150000,
            180000,
            200000,
            250000,
            300000,
            450000,
          ]
        },
        "RENT": {
          "min" : [
              800,
              1000,
              1300,
              1500,
              1700,
              2000
            ],
          "max" : [
            1000,
            1300,
            1500,
            1800,
            2000,
            2300
          ]
        },
      },
      deal_map : {
        "BUY": "For sale",
        "RENT" : "For rent"
      },
      property_type_map : {
        "MLF": "Multi-Family",
        "FRM" : "Farm",
        "RNT" : "Rental",
        "CRE" : "Commercial",
        "LND" : "Land",
        "RES" : "Residential"
      },
    }
  },
  computed: {
    query: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {

    hasMoreFilter() {
      return  this.query.filter.bathroom.min || this.query.filter.bathroom.max
        || this.query.filter.square.min || this.query.filter.square.max;
    },
    clearMoreFilter() {
      this.query.filter.bathroom.min = null;
      this.query.filter.bathroom.max = null;
      this.query.filter.square.min = null;
      this.query.filter.square.max = null;
    },
    bedroomMinClick(option) {
      this.query.filter.bedroom.min = option;
      //this.bedroom_suggest_mode = 'max'
      this.$refs['bedroom_suggest_mode_max'].focus();
    },
    bedroomMaxClick(option) {
      this.query.filter.bedroom.max = option;
      this.apply('bedroom_filter');
    },
    priceRangeMinClick(option) {
      this.query.filter.price.min = option;
      this.price_range_suggest_mode = 'max'
      this.$refs['price_range_suggest_mode_max'].focus();
    },
    priceRangeMaxClick(option) {
      this.query.filter.price.max = option;
      this.apply('price_range_filter');
    },
    money(val) {
      return parseInt(val).toLocaleString('en-US', { style: 'currency', currency: 'USD',  minimumFractionDigits: 0,
        maximumFractionDigits: 0 });
    },
    kFormatter(num) {
      return Math.abs(num) > 3000 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : this.money(Math.sign(num)*Math.abs(num))
    },
    apply(ref){
      if(ref){
        this.$refs[ref].toggle();
      }
      this.$emit('apply', ref)
    }
  },
  created() {

  },
  mounted() {

  },
  unmounted() {

  },
  beforeDestroy() {

  },
  watch: {

  },
}
</script>

<style scoped>

.price-range-suggest-item {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  cursor: pointer;
  padding-left: 20px;
  padding-right: 20px;
}

.price-range-suggest-item:hover {
  background: #f2f2f2;
}

.price-range-suggest-box {
  margin-left: -20px;
  margin-right: -20px;
}
.b-icon-no-text{
  display: inline-block;
  height: 24px;
  margin-left: 0.5rem;
}
</style>
<style>
.desktop-search .field.is-grouped.is-grouped-multiline:last-child{
  margin-bottom: -1rem;
}
</style>
